import { ReactElement } from 'react';
import {
  OktaSignIn,
  AgrocraftArtisian,
  CanvaAuthRedirect,
} from '../pages';
import { canva_endpoints } from '../utils/constants/canva';
import { TutorialVideos } from '../pages/tutorialVideos/index';

export type routeProps = {
  path: string;
  element: React.FC;
};

export const routes: routeProps[] = [
  {
    path: '/',
    element: AgrocraftArtisian,
  },
  {
    path: '/tutorial',
    element: TutorialVideos,
  },
  {
    path: `${canva_endpoints.REDIRECT}`,
    element: CanvaAuthRedirect,
  },
];

export const nonAuthRoutes: {
  path: string;
  element: ReactElement;
}[] = [
    {
      path: '/',
      element: <OktaSignIn />,
    },
    {
      path: 'admin-sign-in',
      element: <OktaSignIn />,
    },
    {
      path: 'sign-in',
      element: <OktaSignIn />,
    },
    // {
    //   path: 'sign-in',
    //   element: <OtpSignInPage />,
    // },
  ];
